import { Grid, Paper } from '@material-ui/core';
import Authorize from "components/Authorize";
import { permissionProfiles } from "components/Authorize/permissionProfiles";
import ActivityListConfirm from './ActivityListConfirm';
import { activityTableStyle } from './style';

const ActivityListConfirmContainer = ({ entities, title }) => {
    const classes = activityTableStyle()

    return (
        <Authorize profile={permissionProfiles.ACTIVITY.APPROVE_PENDING_CLIENT && permissionProfiles.LOAD.LOAD_APPROVE_PRICE}>
            <Paper className={classes.header}>
                <Grid item className={classes.titleContainer} alignItems="center"> 
                    <Grid item>
                        <h3>{title ?? ''}</h3>
                    </Grid>
                </Grid>
            </Paper>
            <div className={classes.activityListConfirmWrapper}>
                <Grid container spacing={2} className={classes.activityListConfirm}>
                    <ActivityListConfirm entities={entities} />
                </Grid>
            </div>
        </Authorize>
    )
}

export default ActivityListConfirmContainer;